import { generatePath } from "react-router";

import type { Option } from "@/lib/gql/__generated__/graphql";

import { useDnD } from "@/hooks/use-dnd";

import { PATHS } from "@/routes/paths";

import { useDeleteOption, useFetchOptionList, useSortOptionList } from "./model";
import { OptionListPagePresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const OptionListPageContainer = ({ hotelID }: Props) => {
	const { data } = useFetchOptionList({ hotelID });

	const { dndItemList, onCancelDnD } = useDnD((data?.optionList.options ?? []) as Array<Option>);
	const editOptionPagePath = () => {
		return {
			edit: (optionID: string) =>
				generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT, { optionID, hotelID }),
			createNewItem: generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.NEW.OPTION.DEFAULT, { hotelID }),
		};
	};

	const { onDeleteOption } = useDeleteOption({ hotelID });
	const { onSaveSort } = useSortOptionList({ hotelID, dndItemList });

	return (
		<OptionListPagePresenter
			hotelID={hotelID}
			onSaveSort={onSaveSort}
			onCancelSort={onCancelDnD}
			onDeleteOption={onDeleteOption}
			editOptionPagePath={editOptionPagePath}
			dndItemList={dndItemList}
		/>
	);
};

OptionListPageContainer.displayName = "OptionListPageContainer";
